export const DEFAULT_CONDITIONS = [
  {
    signal: {
      id: undefined,
    },
    operator: '',
    value: '',
    required: false,
  },
];
